export default defineNuxtRouteMiddleware((to, _from) => {
  // skip middleware on server
  if (import.meta.server) {
    return
  }

  if (import.meta.client) {
    if (getLocal('token') && getLocal('auth_user')) {
      /*
       * No MFA check here on purpose. This middleware used to route users with a pending
       * enrolment to /dashboard/setup-mfa/, gated on a `features` blob in localStorage that
       * nothing in the app ever writes — so the redirect could never fire and the branch was
       * dead. Wiring it to the real flag made it live, and pulling the flag composable into
       * this module's import graph broke CI: the router plugin loads middleware on demand,
       * so a navigation still in flight when a test environment tears down fails to resolve
       * it, and the run exits non-zero with every test passing.
       *
       * Enrolment routing is covered without it — the login gate, the post-registration
       * hand-off in use-post-registration-mfa.js, and the setup page's own guard.
       */
      if (['login', 'dashboard-login', 'register','dashboard-register', 'verify', 'forgot-password', 'dashboard-forgot-password', 'authorization-callback', 'dashboard-authorization-callback'].includes(to.name)) {
        return navigateTo('/dashboard', { external: true })
      }
    } else if (to.path.includes('/dashboard') && !['dashboard-login','dashboard-register', 'dashboard-forgot-password', 'dashboard-reset-password'].includes(to.name)) {
      return navigateTo(generateLoginPageUrl(), { external: true })
    }
  }
})
